import { combineReducers } from "redux";
import { profileReducer } from "../profile/profileReducer"; 
import storage from "redux-persist/lib/storage";
import { persistReducer } from 'redux-persist';
import {ctrlsReducer}  from '../ctrl/ctrlsReducer';
import {projReducer} from '../project/projReducer'
import prjAsnReducer from "../prjasn/prjAsnReducer";
import {revisionReducer} from "../revision/revReducer";
import appReducer from "../app/appReducer";


const persistConfig = {
    key: "root",
    storage,
  };

  const rootReducer = combineReducers({
    // profile: persistReducer(persistConfig, profileReducer),
    profile: profileReducer,
    app: appReducer,
    ctrl: ctrlsReducer,
    project: projReducer,
    prjasn: prjAsnReducer,
    revision: revisionReducer
  });
  
  export default rootReducer;
  